import appInfo from '@/utils/appInfo';
import myWindow from '@/utils/myWindow';
import { version } from '../../package.json';
import { store } from '@/store';
import { EventItem } from '@/store/modules/eventTracking';

const GA_MEASUREMENT_ID = 'G-XCGY2LLHW8';

export const setUserId = (userId: string | null) => {
  console.warn('tagEvent:: user_id', userId);
  if (typeof myWindow.gtag === 'function') {
    myWindow.gtag('config', GA_MEASUREMENT_ID, {
      user_id: userId,
    });
  } else {
    console.warn('tagEvent:: gtag is not found');
  }
};

const baseParams = () => {
  let userStatus = 'Non_Logged_in';
  const userId = store.state.user?.nbUserInfo?.userId ?? 'Unknown';
  if (store.getters.loginSuccess) {
    userStatus = store.getters.userType.isGuest ? 'Guest' : 'Logged_in';
  }
  return {
    Platform: appInfo.gtagPlatform,
    NB_version: version,
    User_status: userStatus,
    User_id: userId,
  };
};

export const sendGoogleTag = (
  event: string,
  value: any,
  Action_type?: string
) => {
  if (!value) return;

  try {
    console.warn(
      'tagEvent:: ',
      event,
      JSON.stringify({ ...value, Action_type, ...baseParams() }, null, 4)
    );
    if (typeof myWindow.gtag === 'function') {
      myWindow.gtag('event', event, { ...value, Action_type, ...baseParams() });
    } else {
      console.warn('tagEvent:: gtag is not found');
    }
    // 保存事件数据到 Vuex
    const eventData: EventItem = {
      eventName: event,
      eventLabel: value.event_label,
    };
    store.commit('eventTracking/addEvent', eventData);
  } catch (error) {
    console.error('Error in sendGoogleTag:', error);
  }
};

export const sendLoadFinishTag = () => {
  const timing =
    performance.timing || performance.getEntriesByType('navigation')[0];
  if (timing) {
    const loadTime = Number(
      (timing.loadEventEnd - timing.fetchStart) / 1000
    ).toFixed(2);
    if (+loadTime > 0) {
      sendGoogleTag(
        'html_finish',
        {
          Page_Load_Time: loadTime,
        },
        'view'
      );
    }
  }
};

export const sendHomePageFinishTag = () => {
  const timing = performance.timing;
  if (!timing) {
    return;
  }

  const nowTime = Date.now();
  const loadTime = Number(((nowTime - timing.loadEventEnd) / 1000).toFixed(2));
  if (loadTime > 0) {
    sendGoogleTag(
      'page_finish',
      {
        Page_Finish_Time: loadTime,
      },
      'view'
    );
  }
};

export const sendClickGoogleTag = (event: string, value: any) => {
  sendGoogleTag(event, value, 'click');
};

export const sendErrorGoogleTag = (value: any) => {
  sendGoogleTag('Error_Event', value, 'submit');
};

export const sendGoalsGoogleTag = (event: string, value: any) => {
  sendGoogleTag(event, value, 'submit');
};

export const sendViewGoogleTag = (event: string, value: any) => {
  sendGoogleTag(event, value, 'view');
};

export const Home_Banner_Click = 'Home_Banner_Click';
export const Home_Banner_Click_Position = {
  Banner: { element_name: 'Banner', event_label: 'Click Banner' },
  LeftAD: { element_name: 'LeftAD', event_label: 'Click Left AD' },
  MiddleAD: { element_name: 'MiddleAD', event_label: 'Click Middle AD' },
  RightAD: { element_name: 'RightAD', event_label: 'Click Right AD' },
};

export const Home_Message_Click = 'Home_Message_Click';
export const Home_Message_Click_Position = {
  Marquee: { element_name: 'Marquee', event_label: 'Click Marquee' },
  Messages: { element_name: 'Messages', event_label: 'Click Message' },
};

export const Home_GameMenu_Click = 'Home_GameMenu_Click';
export const Home_GameMenu_Click_Position: Record<
  number,
  Record<string, string>
> = {
  8: { element_name: 'Favorite', event_label: 'Click Favorite Game Button' },
  1: { element_name: 'Slot', event_label: 'Click Slot Game Button' },
  2: { element_name: 'Lottery', event_label: 'Click Lottery Game Button' },
  3: { element_name: 'Live', event_label: 'Click Live Game Button' },
  4: { element_name: 'Sports', event_label: 'Click Sports Game Button' },
  5: { element_name: 'Cards', event_label: 'Click Cards Game Button' },
  6: { element_name: 'Fishing', event_label: 'Click Fishing Game Button' },
};

export const Home_GamesArea_Click = 'Home_GamesArea_Click';
export const Home_GamesArea_Click_Position = {
  Popular: {
    element_name: 'Popular',
    event_label: 'Click All Popular Game Button',
  },
  Sport: { element_name: 'Sport', event_label: 'Click All Sport Game Button' },
  Lottery: {
    element_name: 'Lottery',
    event_label: 'Click All Lottery Game Button',
  },
  EnterTheGame: { element_name: 'EnterTheGame', event_label: 'Enter The Game' },
  AddFavorite: {
    element_name: 'AddFavorite',
    event_label: 'Add Game To Favorites',
  },
  Third: (name?: string) => {
    return { element_name: name, event_label: `Click All ${name} Game Button` };
  },
};

export const Home_GamesLogo_Click = 'Home_GamesLogo_Click';
export const Home_GamesLogo_Click_Position = {
  Third: (name: string) => {
    return { element_name: name, event_label: `Click ${name} Logo Button` };
  },
};

export const Home_Header_Click = 'Home_Header_Click';
export const Home_Header_Click_Position = {
  Login: { element_name: 'Login', event_label: 'Click Header Login' },
  Register: { element_name: 'Register', event_label: 'Click Header Register' },
  Deposit: { element_name: 'Deposit', event_label: 'Click Header Deposit' },
  RefreshBalance: {
    element_name: 'RefreshBalance',
    event_label: 'Click Header Refresh Balance Button',
  },
  Sidebar: { element_name: 'Sidebar', event_label: 'Click Header Sidebar' },
  DownloadApp: { element_name: 'DownloadApp', event_label: 'Download App' },
};

export const Home_Footer_Click = 'Home_Footer_Click';
export const Home_Footer_Click_Position = {
  Top: { element_name: 'Top', event_label: 'Click Top Button' },
  SharePlatform: (name: string) => {
    return { element_name: name, event_label: `Click ${name} Button` };
  },
};

export const Home_Floating_Click = 'Home_Floating_Click';
export const Home_Floating_Click_Position = {
  Wheel: {
    element_name: 'Wheel',
    event_label: 'Click Wheel Floating Button',
  },
  RedPacket: {
    element_name: 'RedPacket',
    event_label: 'Click Red Packet Floating Button',
  },
  Service: {
    element_name: 'Service',
    event_label: 'Click Service Floating Button',
  },
};

export const Home_Sidebar_Click = 'Home_Sidebar_Click';
export const Home_Sidebar_Click_Position = {
  Games: {
    element_name: 'Games',
    event_label: 'Click Sidebar Popular Games Button',
  },
  Agent: { element_name: 'Agent', event_label: 'Click Sidebar Agent Button' },
  VIP: { element_name: 'VIP', event_label: 'Click Sidebar VIP Button' },
  Deposit: {
    element_name: 'Deposit',
    event_label: 'Click Sidebar Deposit Button',
  },
  Activity: {
    element_name: 'Activity',
    event_label: 'Click Sidebar Activity Button',
  },
  Cashback: {
    element_name: 'Cashback',
    event_label: 'Click Sidebar Cashback Button',
  },
  RedPacket: {
    element_name: 'RedPacket',
    event_label: 'Click Sidebar RedPacket Button',
  },
  PromoCode: {
    element_name: 'PromoCode',
    event_label: 'Click Sidebar Promo Code Claim Button',
  },
  AboutUs: {
    element_name: 'AboutUs',
    event_label: 'Click Sidebar About Us Button',
  },
  PWA: { element_name: 'PWA', event_label: 'Click Sidebar PWA Button' },
  SharePlatform: (name: string) => {
    return { element_name: name, event_label: `Click Sidebar ${name} Button` };
  },
};

export const Footerbar_Click = 'Footerbar_Click';
export const Footerbar_Click_Position = {
  Tabbar: (name: string) => {
    return {
      element_name: name,
      event_label: `Click Footerbar ${name} Button`,
    };
  },
};

export const User_registration = 'User_registration';
export const User_deposit = 'User_deposit';
export const User_withdrawal = 'User_withdrawal';

export const Home_Popup_Click = 'Popup_Click';
export const Home_Popup_Click_Position = {
  FirstDepositPopup: {
    Popup: 'FirstDepositButton',
    event_label: 'Click Button To Deposit',
  },
  RedPacketGrab: {
    Popup: 'RedPacketGrab',
    event_label: 'Click Button To Grab RedPacket',
  },
};

export const Home_Popup_View = 'Popup_View';
export const Home_Popup_View_Position = {
  FirstDeposit: {
    Popup: 'FirstDeposit',
    event_label: 'View Popup First Deposit',
  },
};

export const Home_Popup_Element_Position = {
  HomePopupElementClick: (area: string) => {
    return { element_name: area, event_label: '-' };
  },
};

export const Popup_View_Position = {
  PopupViewClick: (element_name: string, event_label: string) => {
    return { element_name, event_label };
  },
};

export const Agent_Click = 'Agent_Click';
export const Agent_Click_Position = {
  AreaClick: (area: string) => {
    return { element_name: area, event_label: '-' };
  },
};

export const Login_Click = 'Login_Click';
export const Login_Click_Position = {
  LoginClick: (area: string) => {
    return { element_name: area, event_label: '-' };
  },
};

export const Register_Click = 'Register_Click';
export const Register_Click_Position = {
  RegisterClick: (area: string) => {
    return { element_name: area, event_label: '-' };
  },
};

export const Promo_Activity_Click = 'Promo_Activity_Click';
export const Promo_Mission_Click = 'Promo_Mission_Click';
export const Promo_Cashback_Click = 'Promo_Cashback_Click';
export const Promo_Mission_View = 'Promo_Mission_View';

export const Promo_Activity_Click_Position = {
  PromoActivityClick: (area: string) => {
    return { element_name: area, event_label: '-' };
  },
};

export const Promo_Activity_Name_Position = {
  PromoActivityClick: (area: string) => {
    return { element_name: `BannerClick_${area}`, event_label: '-' };
  },
};

export const Promo_Activity_Receive_Position = {
  PromoActivityClick: (area: string) => {
    return { element_name: `Collect_${area}`, event_label: '-' };
  },
};

export const Game_Enter_Click = 'Game_Enter_Click';

export const Game_Enter_Click_Position = {
  GameEnterClick: (area: string) => {
    return { element_name: area, event_label: '-' };
  },
};

export const User_Exit = 'User_exit';
export const User_Churn_7d = 'User_churn_7d';
export const User_Churn_1d = 'User_churn_1d';
export const User_Churn_2d = 'User_churn_2d';
export const User_Exit_Position = {
  get last_action() {
    return store.getters['eventTracking/getLastEventName'] || 'Unknown';
  },
  get element_name() {
    return store.getters['eventTracking/getLastEventLabel'] || 'Unknown';
  },
};

export const User_Churn_Position = {
  UserChurnClick: (area: string) => {
    return {
      last_action: store.getters['eventTracking/getLastEventName'] || 'Unknown',
      element_name:
        store.getters['eventTracking/getLastEventLabel'] || 'Unknown',
      event_label: area,
    };
  },
};

export const User_Last_Click = {
  UserLastClick: () => {
    const Last_Action_Name =
      store.getters['eventTracking/getLastEventName'] || 'Unknown';
    if (Last_Action_Name === 'Game_Enter_Click') {
      const gameName = localStorage.getItem('last_game') || 'Unknown';
      return {
        last_action: Last_Action_Name,
        element_name: gameName,
      };
    } else {
      return {
        last_action: Last_Action_Name,
        element_name:
          store.getters['eventTracking/getLastEventLabel'] || 'Unknown',
      };
    }
  },
};

export const Deposit_Click = 'Deposit_Click';
export const DepositRecords_Click = 'DepositRecords_Click';
export const Withdraw_Click = 'Withdraw_Click';
export const AuditRecords_Click = 'AuditRecords_Click';
export const WithdrawRecords_Click = 'WithdrawRecords_Click';

export const Deposit_Click_Position = {
  AreaClick: (area: string) => {
    return { element_name: area, event_label: '-' };
  },
};
